"use client";

import { useGamePageData } from "@casino/ui/Games/hooks";
import LoginIntro from "@casino/ui/Games/LoginIntro";
import { GameControlsMode } from "@workspace/frontend-ui";
import type { FC } from "react";

type Props = {
  hasFunMode?: boolean;
};

const ModeToggle: FC<Props> = ({ hasFunMode }) => {
  const { isFunMode, setFunMode, isLoggedIn } = useGamePageData();

  const handleChangeMode = (mode: "real" | "fun") => setFunMode(mode === "fun");

  if (!hasFunMode) {
    return (
      <div
        aria-disabled="true"
        data-testid="mode-toggle-fixed-real"
        className="opacity-40 pointer-events-none"
      >
        <GameControlsMode isFunMode={false} />
      </div>
    );
  }

  // pointer-events-none routes the click to the LoginIntro wrapper instead of the mode buttons.
  if (!isLoggedIn) {
    return (
      <LoginIntro>
        <div
          aria-disabled="true"
          data-testid="mode-toggle-locked"
          className="opacity-40 pointer-events-none"
        >
          <GameControlsMode isFunMode />
        </div>
      </LoginIntro>
    );
  }

  return (
    <GameControlsMode isFunMode={isFunMode} changeMode={handleChangeMode} />
  );
};

export default ModeToggle;
